import { resolveStaffModuleAccess } from './staffModulePermissions';

export const VALIDADOR_LIQUIDACIONES_MODULE_ID = 'validador_liquidaciones';

function isCompanyValidadorLiquidacionesGranted(companyPerms) {
  if (companyPerms === undefined) return false;
  const row = (companyPerms || []).find((p) => p.moduleId === VALIDADOR_LIQUIDACIONES_MODULE_ID);
  return row?.hasAccess === true;
}

export function resolveValidadorLiquidacionesAccess(
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
) {
  if (!isCompanyValidadorLiquidacionesGranted(companyPerms)) return false;
  return resolveStaffModuleAccess(
    VALIDADOR_LIQUIDACIONES_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}
